import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import useMergedState from "rc-util/es/hooks/useMergedState";
import { useLayoutEffect } from 'react';
/**
 * returns the merged type of a step or the default type.
 */

var useMergedType = function useMergedType(_ref) {
  var defaultType = _ref.defaultType,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps,
      current = _ref.current,
      defaultCurrent = _ref.defaultCurrent;

  var _a;

  var _useMergedState = useMergedState(defaultCurrent, {
    value: current
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      innerCurrent = _useMergedState2[0],
      updateInnerCurrent = _useMergedState2[1];

  useLayoutEffect(function () {
    if (current === undefined) return;
    updateInnerCurrent(current);
  }, [current]);
  var innerType = typeof innerCurrent === 'number' ? (_a = steps[innerCurrent]) === null || _a === void 0 ? void 0 : _a.type : defaultType;
  var currentMergedType = innerType !== null && innerType !== void 0 ? innerType : defaultType;
  return {
    currentMergedType: currentMergedType,
    updateInnerCurrent: updateInnerCurrent
  };
};

export default useMergedType;